module.exports = __webpack_public_path__ + "static/media/free.e8b6076e.png";